import { render, staticRenderFns } from "./GiftCoupon.vue?vue&type=template&id=ed4e04cc&scoped=true"
import script from "./GiftCoupon.vue?vue&type=script&lang=ts"
export * from "./GiftCoupon.vue?vue&type=script&lang=ts"
import style0 from "./GiftCoupon.vue?vue&type=style&index=0&id=ed4e04cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4e04cc",
  null
  
)

export default component.exports